var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DialogLoading',{attrs:{"message":_vm.loadingMessage,"active":_vm.loading}}),_vm._v(" "),(_vm.showRealStatesGraphic)?_c('div',{staticClass:"graphic-space"},[_c('apexchart',{attrs:{"type":"bar","height":_vm.tamImob,"options":_vm.imobChartOptions,"series":_vm.imobData}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48de6424","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboards/RealStates.vue
// module id = 517
// module chunks = 5